module.exports = __webpack_public_path__ + "img/13.918d072c.jpg";